<template>
	<div class="ReFioPadej">
		<div class="row">
		<!-- <div class="row"> -->
			<label class="col-form-label col-md-12"  >Фамилия</label>
			<div class="col-md-12 ">
			<!-- <div class="col-md-12 "> -->
				<div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Введите фамилию" class="form-control" v-model.lazy="value.surname" @blur="capitalname(value.surname, 'surname')">
						<re-check-multi-language v-model="value.surname"/>
					</div>
				</div>
			</div>
			<label :class="['col-form-label', 'col-md-12', required?'formRequired':'']"><span > <b class="text-uppercase"> Имя </b></span></label>
			<div class="col-md-12">
			<!-- <div class="col-md-12"> -->
				<div :class="['form-group',required?'required':'']" >
					<div class="mb-0 d-flex">
						<input type="text" placeholder="Введите имя" class="form-control" id="name" v-model.lazy="value.name" @blur="capitalname(value.name, 'name')">
						<re-check-multi-language v-model="value.name"/>
						<base-button type="danger" class="no-border my-0 clear-btn" simple icon @click="value.name = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

					</div>
				</div>
			</div>
			<label class="col-form-label col-md-12" >Отчество</label>
			<div class="col-md-12">
			<!-- <div class="col-md-12 d-flex"> -->
				<div class="form-group">
					<div class="mb-0">
						<input type="text" placeholder="Введите отчество" class="form-control" v-model.lazy="value.patronymic" @blur="capitalname(value.patronymic, 'patronymic')">
						<re-check-multi-language v-model="value.patronymic"/>
					</div>
				</div>
			</div>
			
		</div>
		<button class="btn btn-simple btn-primary" @click="showFioPadej()" v-if="!isShown">{{ this.isHiddenText  }}</button>
		<button class="btn btn-simple btn-primary" @click="getFioPadej()" v-if="!isShown && !isHidden">Проставить падежи</button>
		<button class="btn btn-simple btn-warning" @click="clearFioPadej()"  v-if="typeof value.fio_json != 'undefined' && !$GVO.isEmpty(value.fio_json) && !isHidden">Очистить</button>
		<div class="row" v-if="typeof value.fio_json != 'undefined' && !$GVO.isEmpty(value.fio_json) && !isHidden">
			<template v-for="(fioPadej,ind) in value.fio_json">
				<template v-if="typeof masPadejCat[ind] != 'undefined'">
					<label class="col-form-label col-md-12" >{{masPadejCat[ind]}} падеж</label>
				</template>
				<template v-else>
					<label class="col-form-label col-md-12" >{{objPadejCat[ind]}} падеж</label>
				</template>
				<div class="col-md-12">
					<div class="form-group">
						<div class="mb-0">
							<template v-if="typeof masPadejCat[ind] != 'undefined'">
								<input type="text" v-model.lazy="value.fio_json[ind]" :placeholder="'Введите '+masPadejCat[ind]+' падеж'" class="form-control">
							</template>
							<template v-else>
								<input type="text" v-model.lazy="value.fio_json[ind].last_name" :placeholder="'Введите фамилию'" class="form-control">
								<input type="text" v-model.lazy="value.fio_json[ind].first_name" :placeholder="'Введите имя'" class="form-control">
								<input type="text" v-model.lazy="value.fio_json[ind].father_name" :placeholder="'Введите отчество'" class="form-control">
							</template>
						</div>
					</div>
				</div>
			</template>
			<!-- <button class="btn btn-simple btn-warning" @click="clearFioPadej()">Очистить</button> -->
		</div>
	</div>
</template>

<script>
import ReCheckMultiLanguage from 'src/our_components/ReCheckMultiLanguage.vue';

export default {
		name: 'ReFioPadej',
		components: {
			ReCheckMultiLanguage,
		},
		props: {
			value: {
				type: Object,
				default(){
					return{
						name:'',
						patronymic: '',
						surname: '',
						fio_json: []
					}
				}
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: true
			},
			externalParamsValue:{
				type: Object,
				default(){return {}},
			},
		},
		data () {
			return {
				ver: 1,
				masPadejCat: ['Именительный','Родительный','Дательный','Винительный','Творительный','Предложный'],
				objPadejCat: {"nominative":'Именительный',"genitive":'Родительный',"dative":'Дательный',"accusative":'Винительный',"instrumental":'Творительный',"prepositional":'Предложный'},
				isShown: true,
				isHidden: true,
				isHiddenText: 'Показать падежи',
				client_id: '',
			}
		},
		watch:{
			externalParamsValue:{
				deep:true,
				handler(newValue){
					if(newValue.phone && newValue.phone[0]){
						let client = newValue.phone[0].client;
						if(!client) return;
						if(client.name && this.value.name=='') this.value.name = client.name;
						if(client.surname && this.value.surname=='') this.value.surname = client.surname;
						if(client.patronymic && this.value.patronymic=='') this.value.patronymic = client.patronymic;
					}
				}
			}
		},
		computed: {

		},
		methods: {
			getFioPadej(){
				let masFio = [];

				
					if(this.value.surname !='')masFio.push(this.$GVO.capitalize(this.value.surname));
					if(this.value.name !='')masFio.push(this.$GVO.capitalize(this.value.name));
					if(this.value.patronymic !='')masFio.push(this.$GVO.capitalize(this.value.patronymic));

					if(masFio.length>0){
						this.$GVO.ApiCall('GET_PADEJ',{obj:'client',flt:{
							fio:masFio.join(' '), 
							name:this.$GVO.capitalize(this.value.name), 
							patronymic:this.$GVO.capitalize(this.value.patronymic), 
							surname:this.$GVO.capitalize(this.value.surname),
							client_id:this.client_id},
							
						})
						.then((objApi) => {
							if(objApi.success === true && !this.$GVO.isEmpty(objApi.data)){
								// console.log(masFio);
								this.value.fio_json = objApi.data;
								// console.log(objApi.data);
								
							}
						}).catch(errorObjApi => console.error(errorObjApi));
					}

				// console.log('masFio', masFio);
				
			},
			// showFullForm(){
			// 	if(location.pathname.indexOf('/data/clients/add') != -1){this.isShown = true;} else {this.isShown = false;}
			// },
			clearFioPadej(){
				this.value.fio_json = [];
			},
			getClientID(){
				return this.client_id = typeof this.$route.params.client_id == 'undefined'?'-1':this.$route.params.client_id;
				// console.log(client_id);
			},
			showFioPadej(){
				this.isHidden = !this.isHidden;	
				if (this.isHidden) {
					this.isHiddenText = "Показать падежи";
				} else this.isHiddenText = "Скрыть падежи";
			},
			capitalname(val, type){
				// console.log(this.value[type]);
				this.value[type] = this.$GVO.capitalize(val);
				// this.value.name = this.$GVO.capitalize(val);
				this.$emit('change', this.value);
			}
		},
		mounted() {
			this.getClientID();
		},
		
		created(){
			if(location.pathname.indexOf('/data/clients/add') != -1){this.isShown = true;} else {this.isShown = false;}
		}
	}
</script>
<style scoped>
.padej-row {display: flex;}

</style>
